import { useState, useRef } from "react";

export function useTimer() {
  const [elapsed, setElapsed] = useState(0);
  const startRef = useRef<number | null>(null);

  const start = () => {
    startRef.current = Date.now();
  };

  const stop = () => {
    if (startRef.current) {
      const durationSec = Math.floor((Date.now() - startRef.current) / 1000);
      setElapsed(durationSec);
      startRef.current = null;
      return durationSec;
    }
    return 0;
  };

  const reset = () => {
    setElapsed(0);
    startRef.current = null;
  };

  // 👇 новый метод: получить текущую длительность без остановки
  const getElapsed = () => {
    if (startRef.current) {
      return Math.floor((Date.now() - startRef.current) / 1000);
    }
    return elapsed;
  };

  return { elapsed, start, stop, reset, getElapsed };
}
